;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import SuggestedSearchPill from "./SuggestedSearchPill"

const SUGGESTED_SEARCH = [
  { text: "Relationships", width: "w-[140px]" },
  { text: "Anxiety", width: "w-[94px]" },
  { text: "Grief", width: "w-[83px]" },
  { text: "Women", width: "w-[76px]" },
  { text: "LGBTQIA", width: "w-[112px]" },
  { text: "Clinicians", width: "w-[107px]" },
]

function SuggestedSearchPills({ handleUpdateSearch }) {
  return (
    <div
      className={"pt-[15px] min-[800px]:pb-[55px] pb-[35px] flex justify-center"}
      key="suggested-search-pills"
    >
      <div
        className={
          "flex flex-row  max-w-[864px] w-full justify-between flex-wrap overflow-y-hidden h-[38px]"
        }
      >
        <div className="flex flex-col font-medium text-white tracking-[.32px] w-[73px]">
          <div className="h-[19px]">Common</div>
          <div className="h-[19px]">searches:</div>
        </div>

        {SUGGESTED_SEARCH.map(({ text, width }, index) => {
          return (
            <SuggestedSearchPill
              text={text}
              index={index}
              key={`suggested-pill-${index}`}
              width={width}
              onClick={() => {
                handleUpdateSearch({ newSearchTerm: text })
              }}
            />
          )
        })}
      </div>
    </div>
  )
}

export default SuggestedSearchPills
